<template>
  <div class="box box-secondary">
    <div class="box-header with-border">
      <h3 class="box-title"><i class="fa fa-line-chart mr-5"></i>Verkaufsstatistik</h3>
      <div class="box-tools pull-right">
        <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
        </button>
      </div>
    </div>
    <div class="clear"></div>
    <div class="box-body" style="display: block;">
      <div class="row">
        <div class="col-xs-12">
          <template v-if="orders">
            <template v-for="(data, channel) in orders.channels">
              <div :key="channel" class="box box-solid collapsed-box" style="margin-bottom: .5rem !important;">
                <div class="box-header no-border">
                  <h5 class="progress-text" style="margin-bottom: .5rem;">{{ channel | translate }}</h5>
                  <div class="progress-group">
                    <div class="progress sm no-margin">
                      <div
                        v-if="data.orders > 0"
                        class="progress-bar"
                        :class="['progress-bar-' + channel]"
                        :style="'width:' + Math.round(data.orders * 100 / orders.orders) + '%'"
                      >
                      </div>
                      <div v-else class="progress-bar progress-bar-warning" style="width: 0"></div>
                    </div>
                    <div class="row" :class="['text-' + channel]">
                      <div class="col-md-3 col-sm-6 col-xs-12">
                        <div class="description-block small border-right">
                          {{ data.orders }} {{ 'orders' | translate }}
                        </div>
                      </div>
                      <div class="col-md-3 col-sm-6 col-xs-12">
                        <div class="description-block small border-right">
                          {{ data.items }} {{ 'items' | translate }}
                        </div>
                      </div>
                      <div class="col-md-3 col-sm-6 col-xs-12">
                        <div class="description-block small border-right">
                          Ø VK: {{ data.average | currency }}
                        </div>
                      </div>
                      <div class="col-md-3 col-sm-6 col-xs-12">
                        <div class="description-block small">
                          {{ 'total' | translate }}: {{ data.amount | currency }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="data.order_type" class="box-tools pull-right" title="Details einblenden">
                    <button type="button" class="btn btn-box-tool" data-widget="collapse">
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
                <div v-if="data.order_type" class="box-body" style="display: none; padding-left: 5%;">
                  <template v-for="(subChannel, index) in data.order_type">
                    <h5 class="progress-text" style="margin-bottom: .5rem;">{{ channel | translate }}.{{ index }}</h5>
                    <div class="progress-group">
                      <div class="progress sm no-margin">
                        <div v-if="subChannel.orders > 0" class="progress-bar" :class="['progress-bar-' + channel]" :style="'width:' + Math.round(subChannel.orders * 100 / data.orders) + '%'"></div>
                        <div v-else class="progress-bar progress-bar-warning" style="width: 0;"></div>
                      </div>
                      <div class="row" :class="['text-' + channel]">
                        <div class="col-md-3 col-sm-6 col-xs-12">
                          <div class="description-block small border-right">{{ subChannel.orders }} {{ 'orders' | translate }}</div>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12">
                          <div class="description-block small border-right">{{ subChannel.items }} {{ 'items' | translate }}</div>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12">
                          <div class="description-block small border-right">Ø VK: {{ subChannel.average | currency }}</div>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12">
                          <div class="description-block small">{{ 'total' | translate }}: {{ subChannel.amount | currency }}</div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
	props: ['orders'],
}
</script>
<style>
  .progress-bar-schuhede, .progress-bar-selfservice_schuhede {
    background-color: #d4ae85;
  }
  .progress-bar-amazon {
    background-color: #f39c12;
  }
  .progress-bar-spartoo {
    background-color: #DB321B;
  }
  .progress-bar-zalando {
    background-color: #DB321B;
  }
  .progress-bar-ebay {
    background-color: #00c0ef;
  }
  .text-schuhede, .text-selfservice_schuhede {
    color: #d4ae85;
  }
  .progress-bar-ats_de {
    background-color: #65B32E;
  }
  .progress-bar-limango_de {
    background-color: #5E9737;
  }

  .text-amazon {
    color: #f39c12;
  }
  .text-spartoo {
    color: #DB321B;
  }
  .text-zalando {
    color: #DB321B;
  }
  .text-ebay {
    color: #00c0ef;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/StatisticsReport.vue